import { ICooling } from "./types.ts";
import { axiosInstance } from "../axiosConfig.ts";

export const coolingAPI = {
  getCoolingInfo: async (): Promise<ICooling | undefined> => {
    const response = await axiosInstance.get<ICooling | undefined>("/v1/limits/cooldown");
    return response.data;
  },

  refuseLoan: async (): Promise<void> => {
    await axiosInstance.post("/v1/applications/canceled");
  },
};
